import { render } from "./commentItem.vue?vue&type=template&id=784e0d6a&scoped=true"
import script from "./commentItem.vue?vue&type=script&lang=js"
export * from "./commentItem.vue?vue&type=script&lang=js"

import "./commentItem.vue?vue&type=style&index=0&id=784e0d6a&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784e0d6a"]])

export default __exports__